export class CustomDateFormat {
  // public dateFormatLocale: DateFormatLocale = DateFormatLocale.FR;
  public currentLang = 'en';
  private displayData = {
    dateInput: 'M/D/YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  };

  private dateInputData = {
    dateInput: 'M/D/YYYY'
  };

  get display() {
    if (this.currentLang.includes('fr')) {
      return {
        ...this.displayData,
        dateInput: 'DD/MM/YYYY'
      };
    }
    return this.displayData;
  }
  get parse() {
    if (this.currentLang.includes('fr')) {
      return {
        ...this.dateInputData,
        dateInput: 'DD/MM/YYYY'
      };
    }
    return this.dateInputData;
  }
}
